import React from 'react'
import styled from 'styled-components'
import { charcoal, whiteSmoke } from '@sukiai/components/lib/colors'
import { Loading } from '@sukiai/components'

const Container = styled.div`
  max-height: 60vh;
  overflow-y: auto;
  width: 420px;
  padding: 40px 50px 50px 50px;
  background: ${whiteSmoke};
  color: ${charcoal};
  z-index: 2000;
  position: relative;
`

const Heading = styled.div`
  color: black;
  font-size: 22px;
  font-weight: 600; 
  margin-bottom: 20px;
`

const Body = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 18px;
`

const BodyText = styled.div`
`

const LoadingContainer = styled.div`
  position: relative;
  background-color: blue;
  margin-top: 50px;
  margin-bottom: 20px;

`

class EmrNotePullDialog extends React.Component {
  componentWillReceiveProps (nextProps) {
    nextProps.shouldDismiss && this.props.open && nextProps.removeModal()
  }

    handleClose = () => {
      const { dismiss } = this.props
      dismiss()
    }

    render () {
      return (
        <Container onClick={e => e.stopPropagation()}>
          <Body>
            <Heading>
              Refreshing from EMR
            </Heading>
            <BodyText>
              This can take up to 30 seconds.<br />
              Please edit and submit the note from Suki before making more edits in EMR.
            </BodyText>
            <LoadingContainer>
              <Loading />
            </LoadingContainer>
          </Body>
        </Container>
      )
    }
}

export default EmrNotePullDialog
